




























import { Component, Vue, Prop } from 'nuxt-property-decorator'
import { mdiTune } from '@mdi/js'
import { ICatalogFilterItem } from '~/assets/interfaces/catalog'
import { declension } from '~/assets/functions/declension'

@Component({
  components: {
    ComponentCatalogFilter: () =>
      import('~/components/catalog/filter/catalog-filter.vue'),
    ComponentFormButtonIcon: () => import('~/components/form/button-icon.vue'),
    ComponentFormButton: () => import('~/components/form/button.vue'),
    ComponentPopup: () => import('~/components/popup/popup.vue'),
  },
  filters: {
    filterDeclension(number: number) {
      return (
        'Показать ' +
        number.toLocaleString() +
        ' ' +
        declension(number, ['товар', 'товара', 'товаров'])
      )
    },
  },
})
export default class ComponentMobileCatalogFilter extends Vue {
  @Prop({ default: false, type: Boolean }) private loading!: boolean
  @Prop({ type: Array, default: () => [] }) items!: ICatalogFilterItem[]
  @Prop({ type: Number, default: 0 }) amount!: number

  private mdiTune = mdiTune
  private isOpen = false

  private mounted(): void {
    this.$emit('loaded')
  }
}
